// PasswordChangePopup.js
import React, { useState } from "react";

function PasswordChangePopup({ show, onClose, onChangePassword }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }
    if (!currentPassword || !newPassword) {
      setError("Please fill in all fields.");
      return;
    }

    onChangePassword(currentPassword, newPassword); // Pass current and new password to the parent
    setCurrentPassword(""); // Clear inputs
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    onClose(); // Close the popup
  };

  const handleCancel = () => {
    setCurrentPassword(""); // Clear inputs
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    onClose(); // Close the popup
  };

  if (!show) return null; // Render nothing if `show` is false

  return (
    <>
      {/* Overlay for background blur */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent dark overlay
          backdropFilter: "blur(5px)", // Apply blur effect
          zIndex: 1, // Ensure overlay is behind the popup
        }}
        onClick={onClose}
      />

      {/* Popup Window */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          backgroundColor: "white",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
          zIndex: 2, // Ensure popup is above the overlay
        }}
      >
        <h5>Change your password</h5>
        <div>
          Your new password must comply to i-DOCS password complexity rules.
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="Current Password"
        />
        <br></br>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New Password"
        />
        <br></br>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm New Password"
        />
        <div>
          <button onClick={handleSubmit}>OK</button>
          <button onClick={handleCancel}>Cancel</button>
        </div>
      </div>
    </>
  );
}

export default PasswordChangePopup;
